export default {
  recipesNotAllowed: 'Workplace is not configured to use recipes',
  recipesNotCreated: 'No recipes available',
};
